import { api } from '../api'
import type { Drill, PlayerAction } from '@acepoker/contract'

export const generateSequence = async (config: Drill['data']): Promise<PlayerAction[]> =>
  await api().url('/api/drill/generate-sequence').post(config).json()
